export const getTypeFile = (url) => {
    return url.split('.').pop().toString();
}
